




















































import { computed, defineComponent, ref } from "@vue/composition-api";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import {
  InputSubscriptionLevelCreate,
  InputSubscriptionLevelUpdate,
  SubscriptionLevel,
} from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { ERRORS, SUBSCRIPTION_LEVEL_FRAGMENT } from "@/const";
import BaseButtonCreate from "@/components/BaseButtonCreate";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import PageTitle from "@/components/PageTitle";
import CreateLevelView from "./components/CreateLevelView.vue";
import EditLevelView from "./components/EditLevelView.vue";
import LevelsView from "./components/LevelsView.vue";
import NoLevelsView from "./components/NoLevelsView.vue";

export default defineComponent({
  name: "PageSubscriptionLevels",
  components: {
    EditLevelView,
    CreateLevelView,
    LevelsView,
    NoLevelsView,
    BasePage,
    PageTitle,
    BaseButtonCreate,
    EmptyContent,
  },
  setup() {
    const { authUserStrict, userVerificationStatus } = useAuthUser();

    const approved = ref(true);
    const priceList = ref<SubscriptionLevel[]>([]);
    const packageList = ref<PaymentPackage[]>([]);
    const showCreate = ref(false);
    const priceToEdit = ref<SubscriptionLevel | null>(null);
    const loading = ref(false);
    const saveWelcomeMessage = ref<((subjectId: string) => Promise<void | string>) | null>(null);

    const userId = computed(() => authUserStrict.value.id);

    const showEdit = computed(() => {
      return !!priceToEdit.value;
    });

    const closeEdit = () => {
      return (priceToEdit.value = null);
    };
    const openEdit = (id: string) => {
      priceToEdit.value = priceList.value.find(i => i.id === id) || null;
    };

    const getPrices = () => {
      return providers.SubscriptionLevelProvider.find(
        { userIds: [authUserStrict.value.id] },
        SUBSCRIPTION_LEVEL_FRAGMENT
      ).then(r => (priceList.value = r));
    };

    const createLevel = async (data: InputSubscriptionLevelCreate) => {
      try {
        loading.value = true;
        const { id } = await providers.SubscriptionLevelProvider.create({ data });
        await getPrices();
        if (saveWelcomeMessage.value) {
          const resp = await saveWelcomeMessage.value(id);
          if (resp === ERRORS.RESTRICTED_WORD) return;
        }
        showCreate.value = false;
      } finally {
        loading.value = false;
      }
    };

    const updateLevel = async (data: InputSubscriptionLevelUpdate) => {
      try {
        loading.value = true;
        const { id } = await providers.SubscriptionLevelProvider.update({ data });
        await getPrices();
        if (saveWelcomeMessage.value) {
          const resp = await saveWelcomeMessage.value(id);
          if (resp === ERRORS.RESTRICTED_WORD) return;
        }
        closeEdit();
      } finally {
        loading.value = false;
      }
    };

    const deleteLevel = async (id: string) => {
      await providers.SubscriptionLevelProvider.delete({ id });
      closeEdit();
      await getPrices();
    };

    const getData = () => {
      getPrices();
      approved.value = userVerificationStatus.value === UserVerificationStatus.VERIFIED;
      providers.PaymentPackageProvider.findAll({ type: [PaymentPackageEnum.SUBSCRIPTION] }).then(
        r => (packageList.value = r)
      );
    };

    getData();

    return {
      userId,
      approved,
      showEdit,
      loading,
      priceList,
      packageList,
      showCreate,
      saveWelcomeMessage,
      priceToEdit,
      closeEdit,
      openEdit,
      createLevel,
      updateLevel,
      deleteLevel,
    };
  },
});
